import Router from './routes/routes';
import Navbar from './components/navbar/Navbar';
import Footer from './components/Footer/Footer';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-phone-input-2/lib/style.css";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { whatsapp } from './assets/imagesPath';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import { useState } from 'react';

import { useGetContactSettingsQuery } from './services/Api';

function App() {
  const { data: settingsData } = useGetContactSettingsQuery();
  const settings = settingsData?.status ? settingsData.data : { whatsapp_number: '+923000828456' };

  const formatWhatsApp = (num) => num?.replace(/[^0-9]/g, '').replace(/^0/, '92');

  const openWhatsAppChat = () => {
    window.open(`https://wa.me/${formatWhatsApp(settings.whatsapp_number)}`, '_blank');
  };

  // Date-based Eid holiday popup (March 19 - March 23, 2026)
  const isEidHolidayPeriod = () => {
    const now = new Date();
    const start = new Date(2026, 2, 19); // March 19, 2026
    const end = new Date(2026, 2, 23, 23, 59, 59); // March 23, 2026
    return now >= start && now <= end;
  };

  const [popupVisible, setPopupVisible] = useState(isEidHolidayPeriod());

  const closePopup = () => {
    setPopupVisible(false);
  };

  return (
    <>
      {popupVisible && (
        <div className='popupOverlay' onClick={closePopup}>
          <div className='popup' onClick={(e) => e.stopPropagation()}>
            <p className='popupTitle'>🌙 عید مبارک 🌙</p>
            <p className='popupHeading'>معزز کسٹمرز</p>
            <p className='popupMessage'>تمام آرڈرز جو 19 مارچ کے بعد کیے گئے ہیں وہ عید الفطر کی چھٹیوں کے بعد مکمل کیے جائیں گے ۔</p>
            <button className='popupCloseBtn' onClick={closePopup}>OK</button>
          </div>
        </div>
      )}
      <ScrollToTop />
      <Navbar />
      <Router />
      <Footer />
      <img src={whatsapp} className='whatsappImg' onClick={openWhatsAppChat} />
    </>
  );
}

export default App;